import React, { useEffect } from 'react';
import { Prompt } from 'react-router-dom';

export const UnsavedFormPrompt = ({ when, ...props }) => {
  const message =
    'This page is asking you to confirm that you want to leave - data you have entered may not be saved.';

  useEffect(() => {
    if (when) {
      window.onbeforeunload = e => {
        e.preventDefault();
        e.returnValue = '';
      };
    } else {
      window.onbeforeunload = () => {};
    }
    return () => {
      window.onbeforeunload = () => {};
    };
  }, [when]);

  return <Prompt when={when} message={message} {...props} />;
};
